/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconZoomOut = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M18.875 9.811c.001 5.005-4.057 9.063-9.062 9.064C4.808 18.876.75 14.818.749 9.813.748 4.808 4.806.75 9.811.749h.001a9.063 9.063 0 0 1 9.063 9.062zM5.25 9.749h9M16.221 16.219l7.029 7.03" />
      </g>
    </svg>
  ),
);
